import { Modal, inputCls, btnPrimary } from "../bits";

export function CoordinatorFormModal({ open, mode, onClose, form, setForm, schools, busy, onSave }) {
  return (
    <Modal open={open} onClose={onClose} title={mode === "edit" ? "تعديل حساب المنسق" : "إنشاء حساب منسق"} testid="coordinator-form-modal">
      <div className="space-y-3">
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">الاسم *</label>
          <input data-testid="coordinator-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">البريد الإلكتروني *</label>
          <input data-testid="coordinator-email-input" type="email" value={form.email} disabled={mode === "edit"}
            onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} dir="ltr" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">اسم المستخدم للدخول (اختياري — يمكّن الدخول بدون بريد)</label>
          <input data-testid="coordinator-username-input" value={form.username || ""}
            onChange={(e) => setForm({ ...form, username: e.target.value })} className={inputCls} dir="ltr" placeholder="مثال: hail.boys01" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">{mode === "edit" ? "كلمة مرور جديدة (اتركها فارغة لعدم التغيير)" : "كلمة المرور *"}</label>
          <input data-testid="coordinator-password-input" type="password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} dir="ltr" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">المدرسة</label>
          <select data-testid="coordinator-school-select" value={form.school_id} onChange={(e) => setForm({ ...form, school_id: e.target.value || null })} className={inputCls}>
            <option value="">— بدون مدرسة —</option>
            {schools.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
        <button data-testid="coordinator-save-btn" onClick={onSave} disabled={busy} className={`${btnPrimary} w-full justify-center`}>
          {busy ? "جارٍ الحفظ …" : "حفظ"}
        </button>
      </div>
    </Modal>
  );
}
